// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var DataDependency$SmartcutsMacros = require("./shared/DataDependency.bs.js");
var Webapi__FileReader$SmartcutsMacros = require("../Webapi/Webapi__FileReader.bs.js");
var PasteInContentEditableCommand$SmartcutsMacros = require("./PasteInContentEditableCommand.bs.js");
var Webapi__SecureContext__SubtleCrypto$SmartcutsMacros = require("../Webapi/Webapi__SecureContext__SubtleCrypto.bs.js");
var Selection__ContentEditableSelectionOrCursor$SmartcutsMacros = require("../Selection/Selection__ContentEditableSelectionOrCursor.bs.js");
var SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros = require("../SelectionSemantics/SelectionSemantics__ContentEditableSelectionOrCursorSemantics.bs.js");

function notResolved_encode(v) {
  return Js_dict.fromArray([
              [
                "hash",
                Decco.stringToJson(v.hash)
              ],
              [
                "size",
                Decco.floatToJson(v.size)
              ]
            ]);
}

function notResolved_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var hash = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hash"), null));
  if (hash.TAG === /* Ok */0) {
    var size = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "size"), null));
    if (size.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                hash: hash._0,
                size: size._0
              }
            };
    }
    var e = size._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".size" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = hash._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".hash" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function image_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ImageFromCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ImageFromCommand */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NotResolved" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = notResolved_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NotResolved */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function image_encode(v) {
  if (v.TAG === /* NotResolved */0) {
    return [
            "NotResolved",
            notResolved_encode(v._0)
          ];
  } else {
    return [
            "ImageFromCommand",
            Decco.intToJson(v._0)
          ];
  }
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "positioning",
                Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_encode(v.positioning)
              ],
              [
                "image",
                image_encode(v.image)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var positioning = Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positioning"), null));
  if (positioning.TAG === /* Ok */0) {
    var image = image_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
    if (image.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                positioning: positioning._0,
                image: image._0
              }
            };
    }
    var e = image._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".image" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = positioning._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".positioning" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify(param) {
  var image = param.image;
  var tmp;
  if (image.TAG === /* NotResolved */0) {
    var match = image._0;
    tmp = "NotResolved({hash: " + (match.hash + (", size: " + (match.size.toString() + "})")));
  } else {
    tmp = "ImageFromCommand(commandId=" + (String(image._0) + "})");
  }
  return "{ positioning: " + (Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.stringify(param.positioning) + (", image: " + (tmp + " }")));
}

function fromBlobWithSelection(selection, blob) {
  var fileReader = Webapi__FileReader$SmartcutsMacros.make(undefined);
  return Webapi__FileReader$SmartcutsMacros.readAsArrayBufferPromise(fileReader, blob).then(function (result_maybeArrayBuffer) {
              if (result_maybeArrayBuffer.TAG === /* Ok */0) {
                var arrayBuffer = OptionUtils$SmartcutsMacros.getExn("Expect to get array buffer from FileReader.readAsArrayBufferPromise()", result_maybeArrayBuffer._0);
                return Webapi__SecureContext__SubtleCrypto$SmartcutsMacros.digest("sha256", arrayBuffer).then(function (hashBuffer) {
                            var hash = Belt_Array.map(Array.from(new Uint8Array(hashBuffer)), (function (b) {
                                      return b.toString(16).padStart(2, "0");
                                    })).join("");
                            var size = blob.size;
                            return Promise.resolve({
                                        positioning: selection,
                                        image: {
                                          TAG: /* NotResolved */0,
                                          _0: {
                                            hash: hash,
                                            size: size
                                          }
                                        }
                                      });
                          });
              }
              var error = result_maybeArrayBuffer._0;
              if (error) {
                console.error("FileReader did error while trying to read image blob: ", error._0);
                return Util$SmartcutsMacros.logAndRaiseJsError("FileReader did error while trying to read image blob");
              } else {
                return Util$SmartcutsMacros.logAndRaiseJsError("FileReader did abort while trying to read image blob");
              }
            });
}

var Recording = {
  t_encode: t_encode,
  t_decode: t_decode,
  image_encode: image_encode,
  image_decode: image_decode,
  notResolved_encode: notResolved_encode,
  notResolved_decode: notResolved_decode,
  stringify: stringify,
  fromBlobWithSelection: fromBlobWithSelection
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "positioning",
                Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.ContentEditablePasteSelectionWithSemantics.t_encode, v.positioning)
              ],
              [
                "image",
                Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.image)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var positioning = Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.ContentEditablePasteSelectionWithSemantics.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "positioning"), null));
  if (positioning.TAG === /* Ok */0) {
    var image = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
    if (image.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                positioning: positioning._0,
                image: image._0
              }
            };
    }
    var e = image._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".image" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = positioning._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".positioning" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$1(param) {
  return "{positioning: " + (Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.ContentEditablePasteSelectionWithSemantics.stringify, param.positioning) + (", image:" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, param.image) + "}")));
}

function fromRecordingCommandValue(param) {
  var image = param.image;
  var contentEditableSelectionOrCursor = param.positioning;
  var semantics = SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.ofSelectionOrCursor(contentEditableSelectionOrCursor);
  var tmp;
  tmp = image.TAG === /* NotResolved */0 ? Util$SmartcutsMacros.logAndRaiseJsError("Expect Resolved image when convert PasteImageCommand fromRecordingCommandValue") : ({
        TAG: /* ImageFromCommand */7,
        _0: {
          commandId: image._0,
          image: /* NotResolved */0
        }
      });
  return {
          positioning: {
            contentEditableSelectionOrCursor: contentEditableSelectionOrCursor,
            semantics: semantics
          },
          image: tmp
        };
}

function updateSelector(f, param) {
  return {
          positioning: Curry._2(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.ContentEditablePasteSelectionWithSemantics.updateSelector, f, param.positioning),
          image: param.image
        };
}

var Authoring = {
  ContentEditablePasteSelectionWithSemantics: undefined,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1,
  fromRecordingCommandValue: fromRecordingCommandValue,
  updateSelector: updateSelector
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "positioning",
                SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.Semantic.t_encode(v.positioning)
              ],
              [
                "image",
                Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.image)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var positioning = SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positioning"), null));
  if (positioning.TAG === /* Ok */0) {
    var image = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
    if (image.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                positioning: positioning._0,
                image: image._0
              }
            };
    }
    var e = image._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".image" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = positioning._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".positioning" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function selectorGet(param) {
  return SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.Semantic.selectorGet(param.positioning);
}

function stringify$2(param) {
  return "{positioning: " + (SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.Semantic.toHumanReadable(param.positioning) + (", image: " + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, param.image) + "}")));
}

function fromAuthoringCommand(param) {
  return {
          positioning: SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.atIndex(0, param.positioning.semantics),
          image: param.image
        };
}

var Playback = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  selectorGet: selectorGet,
  stringify: stringify$2,
  fromAuthoringCommand: fromAuthoringCommand
};

var CommandValue = {
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

exports.CommandValue = CommandValue;
/* Util-SmartcutsMacros Not a pure module */
